import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await login(email, password);
      toast.success('Login successful!');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem'
    }}>
      <div style={{ width: '100%', maxWidth: '400px' }}>
        {/* Main Login Card */}
        <div className="card" style={{ 
          borderRadius: '16px', 
          boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
          border: 'none',
          overflow: 'hidden'
        }}>
          {/* Header Section */}
          <div style={{
            background: 'linear-gradient(135deg, #343a40 0%, #495057 100%)',
            padding: '2rem',
            textAlign: 'center',
            color: 'white'
          }}>
            <div style={{
              width: '80px',
              height: '80px',
              background: 'rgba(255,255,255,0.2)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 1rem',
              backdropFilter: 'blur(10px)'
            }}>
              <i className="fas fa-building" style={{ fontSize: '32px', color: 'white' }}></i>
            </div>
            <h1 style={{ fontSize: '24px', fontWeight: '700', margin: '0 0 0.5rem', letterSpacing: '1px' }}>
              CALIBER
            </h1>
            <p style={{ margin: '0', opacity: '0.9', fontSize: '14px' }}>
              Payroll Management System
            </p>
          </div>

          {/* Form Section */}
          <div style={{ padding: '2rem' }}>
            <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#343a40', margin: '0 0 0.5rem' }}>
                Welcome Back
              </h2>
              <p style={{ color: '#6c757d', margin: '0', fontSize: '14px' }}>
                Sign in to access your dashboard
              </p>
            </div>
            
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">Email Address</label>
                <div style={{ position: 'relative' }}>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    style={{
                      paddingLeft: '3rem',
                      height: '48px',
                      border: '2px solid #e9ecef',
                      borderRadius: '8px',
                      fontSize: '14px'
                    }}
                  />
                  <i className="fas fa-envelope" style={{
                    position: 'absolute',
                    left: '1rem',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: '#6c757d'
                  }}></i>
                </div>
              </div>
              
              <div className="form-group">
                <label className="form-label">Password</label>
                <div style={{ position: 'relative' }}>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    style={{
                      paddingLeft: '3rem',
                      height: '48px',
                      border: '2px solid #e9ecef',
                      borderRadius: '8px',
                      fontSize: '14px'
                    }}
                  />
                  <i className="fas fa-lock" style={{
                    position: 'absolute',
                    left: '1rem',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: '#6c757d'
                  }}></i>
                </div>
              </div>
              
              <button
                type="submit"
                className="btn w-100"
                disabled={loading}
                style={{
                  background: 'linear-gradient(135deg, #007bff, #0056b3)',
                  border: 'none',
                  height: '48px',
                  borderRadius: '8px',
                  color: 'white',
                  fontSize: '16px',
                  fontWeight: '600',
                  boxShadow: '0 4px 12px rgba(0,123,255,0.3)',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
                onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
              >
                {loading ? (
                  <>
                    <div className="spinner" style={{ width: '16px', height: '16px', marginRight: '0.5rem' }}></div>
                    Signing in...
                  </>
                ) : (
                  <>
                    <i className="fas fa-sign-in-alt" style={{ marginRight: '0.5rem' }}></i>
                    Sign In
                  </>
                )}
              </button>
            </form>
          </div>
        </div>



        {/* Footer */}
        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
          <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '13px', margin: '0' }}>
            © 2024 Caliber Payroll Management System
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;